import { setGlobalOptions } from './loader-utils/merge-options';
export function setLoaderOptions(options) {
  setGlobalOptions(options);
}
//# sourceMappingURL=set-loader-options.js.map